<template>
  <div class="tab-btn" :style="{ height: height }">
    <el-tabs v-model="active" type="card" @tab-click="handleTab">
      <el-tab-pane
        v-for="v in tabs"
        :label="v.label"
        :name="v.value"
        :key="v.value"
      ></el-tab-pane>
    </el-tabs>
    <div class="btn">
      <slot name="btn"></slot>
    </div>
    <div class="table">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBtn',
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '300px'
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 页面数据
      active: ''
    }
  },
  created() {
    this.active = this.activeTab || this.tabs[0].value
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    handleTab(e) {
      this.$emit(
        'tab-click',
        this.tabs.find(e => e.value === this.active)
      )
    }
  }
}
</script>

<style scoped lang="less">
.tab-btn {
  position: relative;
  height: 100%;
  .btn {
    position: absolute;
    right: 0;
    top: -2px;
  }
  .table {
    height: calc(100% - 35px);
  }
}
</style>
